var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import defaultUserPicture from "../../assets/default_profile.svg";
var PictureWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    width: 100%;\n    padding: 1rem;\n    box-sizing: border-box;\n    border-bottom: 1px solid ".concat(theme.borderContent(), ";\n  ");
});
var Picture = styled.picture(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  max-height: 300px;\n  max-width: 300px;\n  border-radius: 50%;\n"], ["\n  width: 100%;\n  max-height: 300px;\n  max-width: 300px;\n  border-radius: 50%;\n"])));
var DefaultImage = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  max-height: 300px;\n  max-width: 300px;\n  border-radius: 50%;\n  object-fit: cover;\n  object-position: center;\n  aspect-ratio: 1;\n"], ["\n  width: 100%;\n  max-height: 300px;\n  max-width: 300px;\n  border-radius: 50%;\n  object-fit: cover;\n  object-position: center;\n  aspect-ratio: 1;\n"])));
var ProfilePicture = function (_a) {
    var image = _a.image;
    return (React.createElement(PictureWrapper, null,
        React.createElement(Picture, null,
            React.createElement("source", { srcSet: image }),
            React.createElement(DefaultImage, { src: defaultUserPicture, alt: "default profile picture" }))));
};
export default ProfilePicture;
var templateObject_1, templateObject_2, templateObject_3;
